module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "ch-title"
  }, [_c('a', {
    attrs: {
      "id": "pageviii"
    }
  }, [_vm._v("Acknowledgements")])]), _c('a', {
    attrs: {
      "id": "pageviii"
    }
  }, [_c('p', {
    staticClass: "indent1"
  }, [_vm._v("One name may appear on the cover of this book, but many people deserve credit for making this publication a reality. Inspiration and my introduction to history was a direct result of my parents, Stephen and Melanie Greenwalt. From an early age they nurtured my inquisitive nature in history, fueled my interest to learn more about the people of yesteryear, and encouraged me in my career choices. Although my father is battling dementia, the times we spent tramping around battlefields and historic sites are memories I’ll cherish forever. A mental illness cannot take that away from him, me, or our family. To my brother, Patrick, and sister, Adrienne: thank you for the encouraging words, trekking the various fields with your older brother, and providing a sounding board for ideas.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container1a"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pg8_a.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Photo Credits: Phillip S. Greenwalt (psg); Library of Congress (loc); Chris Mackowski (cm); Museum of the American Revolution (moar); National Archives (NA); New York Public Library (nypl); Pennsylvania State Archives (pasa); Terry Rensel (tr); Evan Sharko (es); Wikipedia Commons(wc); Yale (y). ("), _c('span', {
    staticClass: "small_1"
  }, [_vm._v("psg")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Gordon Morgan, thank you for reading, re-reading, answering emails, and being a great proofreader and positive influence on the book. Rob Orrison, the co-founder of the series, thank you for doing the same in regard to the history and also making sure I could have a few moments of hilarity as a break from the seriousness of writing this book. Looking forward to reversing roles for your upcoming publication! To Tara Hatmaker for her amazing ability to fit all the various pieces together in layout to make this book come alive, thank you for all your work on this project. Also, to Dan Davis for his insight on Valley Forge during the American Battlefield Trust Teacher Institute in 2018 and also for reviewing one of the appendices for this book. To Chris Mackowski who saw this through to the finish line, thanks for the helping hand.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "pageviii"
    }
  }, [_vm._v("To Castle, Patty, and Ivan, who strolled around Philadelphia in June 2018, on one of the hottest days ")]), _c('a', {
    attrs: {
      "id": "pageix"
    }
  }, [_vm._v("of the year to find sites attributed to the 1777-78 campaign. Little did they know when they asked for me to pick them up from a concert and drive them to the airport, there would be a historical detour enroute. Thanks for sweltering in the heat and being a good sport about it all!")])]), _c('a', {
    attrs: {
      "id": "pageix"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("To historian Eric Olsen of Morristown National Historical Park, who read over the initial chapters, thank you for lending a critical eye to making this work better. Your wit and sense of humor, along with the discussions of the various encampments, helped bring this history into better focus. To Jonathan Parker, the Chief of Interpretation at Valley Forge National Historical Park, thank you for the positive words, connections, and having staff lend their expertise to the chapters dedicated to the encampment. A thank you needs to be extended as well to Alyse Van De Putte, from the Museum of the American Revolution, for her assistance in gaining access to the Trego painting.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("From Ted Savas, to Sarah Keeney, to Mary Gutzke, and the entire Savas Beatie team, thank you for believing in this series and allowing the great crew at Emerging Revolutionary War to share their passion for telling America’s military history in book form. Edward Alexander’s maps are an invaluable addition to making the hallowed ground accessible to readers. Evan Sharko, a great young historian, journeyed around Pennsylvania and New Jersey to take photographs for me. Thank you! Travis Shaw, another great historian, shared his knowledge on the winter encampment at Wilmington, Delaware, which details another side of the winter that won the war. Mark Maloy reminded us, through a different appendix in this book, about where Valley Forge resides in our collective memory.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("For one other person: to “Red,” who understands that sharing my passion for American history is the musical cadence my heart beats to.")]), _vm._v(" "), _c('h3', {
    staticClass: "fm-sub"
  }, [_vm._v("For the Emerging Revolutionary War Series")]), _vm._v(" "), _c('p', {
    staticClass: "rind"
  }, [_vm._v("Theodore P. Savas, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("publisher")])]), _vm._v(" "), _c('p', {
    staticClass: "rind"
  }, [_vm._v("Sarah Keeney, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("editorial consultant")])]), _vm._v(" "), _c('p', {
    staticClass: "rind"
  }, [_vm._v("Chris Mackowski, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("advisory editor")])]), _vm._v(" "), _c('p', {
    staticClass: "rind"
  }, [_vm._v("Phillip S. Greenwalt, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("series editor")])]), _vm._v(" "), _c('p', {
    staticClass: "rind"
  }, [_vm._v("Robert Orrison, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("chief historian")])]), _vm._v(" "), _c('p', {
    staticClass: "rind"
  }, [_vm._v("Gordon Morgan, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("copyeditor")])]), _vm._v(" "), _c('p', {
    staticClass: "rind"
  }, [_vm._v("Maps by Edward Alexander")]), _vm._v(" "), _c('p', {
    staticClass: "rind"
  }, [_vm._v("Design and layout by Tara Hatmaker and Chris Mackowski")])]), _c('div', {
    staticClass: "img_container1a"
  }, [_c('a', {
    attrs: {
      "id": "pageix"
    }
  }), _c('a', {
    attrs: {
      "id": "pagex"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pg16_a.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("This statue of George Washington at Valley Forge, considered the most accurate of all, is a Gorham Manufacturing Companycasted copy of the one sculpted by Jean-Antoine Houdon that resides in the Virginia State Capitol in Richmond. Permission was granted by the General Assembly of Virginia in 1910 to Gorham to make copies. ("), _c('span', {
    staticClass: "small_1"
  }, [_vm._v("psg")]), _vm._v(")")])])]), _c('a', {
    attrs: {
      "id": "pagex"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30bd1f37","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Acknowledgements.vue
// module id = 78
// module chunks = 0